import { TranslationString } from '../localization';
import { WsEvent, WsEventBase } from '../ws/server';
import { MessageServerRest } from '../chatMessages';
import { BaseResponseCode } from '../network';
import { ScenarioDataServer } from '../scenario';
import { AIIntentKind, AITarget } from '../smartbotAIInfo';
import { AITarifficationServer } from '../tariffication';

export enum AIAggregatedDocType {
  pdf = 'pdf',
  site = 'site'
}

export enum AIImplType {
  openAi = 'open_ai'
}

export type AIBotPayload = {
  name: string;
  target: AITarget;
  company_description: string | null;
  intent_kind: AIIntentKind;
  intent_text?: string;
  faq: string | null;
  limitations: string | null;
  model_type: AIModelKind;
  question_prompt: string;
  context_prompt: string;
  show_used_sources?: boolean;
};

export type AIUploadDocServerResponse = {
  agg_key: string;
};

export type AIUploadDocServerError =
  | {
      fields: Record<string, Array<string>>;
    }
  | AIDocError;

export type AIDocError = {
  code: AIDocErrorCode | number;
  text: string;
};

export type AIDocServer = {
  id: string;
  url: string;
  type: AIAggregatedDocType;
  cost: number;
  date_created: string;
  progress: number;
  errors?: AIDocError[];
};

export type AIDocsServer = {
  docs: AIDocServer[];
};

export type AIBotScenarioDataServer = ScenarioDataServer & {
  channel_ids?: string[] | null;
};

export type AIBotServer = {
  _id: string;
  test_messages_available: number;
  date_created: string;
  impl?: AIImplType;
  extra?: {
    scenarios?: AIBotScenarioDataServer[];
    channel_ids?: string[] | null; // null - когда подключены все каналы проекта
  };
  tariffication: AITarifficationServer;
} & AIBotPayload;

export enum AIBotGetError {
  notFound = 'bot_not_found'
}

export const mapAIBotGetErrorToTitle =
  (code: AIBotGetError): TranslationString =>
  (t) =>
    t(`smartbotAI.errors.get.${code}`, {
      ns: 'entities'
    });

export type SessionDataServer = {
  session_id: string;
  subscription_token: string;
  subscription_channel: string;
  test_messages_available: number;
};

export type WsEventAIDemoMessage = WsEventBase<
  WsEvent.aiDemoMessage,
  MessageServerRest
>;

export enum SmartbotAIWidgetError {
  noTestMessagesAvailable = 'no_test_messages_available'
}

export const mapSmartbotAIWidgetErrorToMessage =
  (code: SmartbotAIWidgetError): TranslationString =>
  (t) =>
    t(`smartbotAI.errors.widget.${code}`, {
      ns: 'entities'
    });

export enum AIDocErrorResponseCode {
  internalError = 'internal_error',
  externalError = 'external_error',
  notSupported = 'not_supported'
}

export type AIDocErrorCode = BaseResponseCode | AIDocErrorResponseCode;

export enum AIModelKind {
  gpt35 = 'gpt_35',
  gpt4oMini = 'gpt_4o_mini',
  gpt4o = 'gpt_4o',
  gpt41 = 'gpt_4_1',
  gpt41Mini = 'gpt_4_1_mini',
  gpt41Nano = 'gpt_4_1_nano',
  o1 = 'o1',
  o3 = 'o3',
  gpt5Nano = 'gpt_5_nano',
  gpt51 = 'gpt_5_1',
  gpt52 = 'gpt_5_2',
  gpt55 = 'gpt_5_5',
  gpt54Mini = 'gpt_5_4_mini',
  gpt54Nano = 'gpt_5_4_nano',
  yandexGpt = 'yandex_gpt',
  yandexGptLite = 'yandex_gpt_lite'
}
